import * as React from "react";
import { useRouteError } from "react-router-dom";

const ErrorPage = () => {
  const error = useRouteError();

  let errorMessage = "An unexpected error occurred.";

  if (error instanceof Error) {
    errorMessage = error.message;
    console.log('e', error.message)
  } else if (typeof error === "object" && error !== null) {
    // Możliwy Response-like obiekt
    if ("statusText" in error && typeof error.statusText === "string") {
      errorMessage = error.statusText;
    } else if ("message" in error && typeof error.message === "string") {
      errorMessage = error.message;
    } else {
      errorMessage = JSON.stringify(error);
    }
  } else if (typeof error === "string") {
    errorMessage = error;
  }

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{errorMessage}</i>
      </p>
    </div>
  );
};

export default ErrorPage;
